import StudyBudgetVisitCreate from './StudyBudgetVisitCreate'
import StudyBudgetVisitDelete from './StudyBudgetVisitDelete'
import { fetchStudyBudgetVisits } from 'actions/studies/studyBudgetVisitActions'
import EmptyList from 'components/common/EmptyList'
import Modal from 'components/common/Modal'
import Table from 'components/common/tables/Table'
import SectionHeaderMenu from 'components/nav/SectionHeaderMenu'
import { useAuth } from 'hooks/useAuth'
import useModal from 'hooks/useModal'
import _ from 'lodash'
import { MDBCardBody } from 'mdbreact'
import React, { useEffect, useState, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'

const StudyBudgetVisitList = () => {
  // hooks
  const {
    modalOpen,
    headerText,
    setHeaderText,
    formId,
    footer,
    setFooter,
    actions,
    setActions,
    selected,
    setSelected,
    params,
    setParams,
    setModalState,
  } = useModal()
  const auth = useAuth()
  const dispatch = useDispatch()

  // redux hooks
  const { studyBudgetVisitsAvailable, lastAction } = useSelector(
    (state) => state.studyBudgetVisits
  )

  // local state
  const [tableData, setTableData] = useState({
    columns: [
      {
        label: '#',
        field: 'id',
        sort: 'desc',
      },
      {
        label: 'Sponsor Study Name',
        field: 'study.name',
        sort: 'desc',
        minimal: 'lg',
      },
      {
        label: 'Budget Visit',
        field: 'budget_visit.name',
        sort: 'desc',
        minimal: 'lg',
      },
      {
        label: 'Date Created (UTC)',
        field: 'created_at',
        date: true,
        sort: 'desc',
      },
      {
        label: '',
        field: 'buttons',
        sort: 'disabled',
        minimal: 'lg',
      },
    ],
  })

  const toggleModal = useCallback(
    (e, type, item) => {
      if (e) e.preventDefault()

      if (type === 'new') {
        setHeaderText('New Study Budget Visit')
        setFooter(true)
        setActions([
          {
            text: 'Submit',
            color: 'primary',
            additionalProps: {
              form: formId,
              type: 'submit',
            },
          },
        ])
      } else if (type === 'delete') {
        setHeaderText('Delete Study Budget Visit')
        setFooter(true)
        setActions([
          {
            text: 'Delete',
            color: 'danger',
            additionalProps: {
              form: formId,
              type: 'submit',
            },
          },
        ])
        setSelected(item)
      }
      if (type) {
        setModalState(true)
      } else {
        setModalState(false)
      }
    },
    [formId, setActions, setFooter, setHeaderText, setModalState, setSelected]
  )

  useEffect(() => {
    dispatch(fetchStudyBudgetVisits('list'))
  }, [dispatch])

  const sectionHeaderMenu = {
    order: 2,
    show: true,
    linkItems: [
      {
        name: 'Create',
        url: `/admin/budget`,
        exact: true,
        additionalProps: {
          active: true,
          onClick: (e) => toggleModal(e, 'new'),
          className: 'btn-sm',
        },
      },
    ],
  }

  const renderModalBody = () => {
    if (headerText === 'New Study Budget Visit') {
      return (
        <StudyBudgetVisitCreate
          formId={formId}
          params={params}
          setParams={setParams}
          closeModal={(e) => setModalState(false)}
        />
      )
    } else if (headerText === 'Delete Study Budget Visit') {
      return (
        <StudyBudgetVisitDelete
          formId={formId}
          selected={selected}
          closeModal={(e) => setModalState(false)}
        />
      )
    }

    return ''
  }

  const renderTable = () => {
    if (_.size(studyBudgetVisitsAvailable)) {
      return (
        <Table
          section="Study Budget Visit"
          tableData={tableData}
          setTableData={setTableData}
          rowData={studyBudgetVisitsAvailable}
          sort={['id', 'desc']}
          toggleModal={toggleModal}
          updatedState={lastAction}
          downloadableCSV
          deleteButton
        />
      )
    } else if (_.isEmpty(studyBudgetVisitsAvailable)) {
      return (
        <EmptyList
          name="study budget vist"
          namePlural="study budget visits"
          userRole={auth?.user?.user_level}
          createElement={
            <span className="link" onClick={(e) => toggleModal(e, 'new')}>
              Create
            </span>
          }
        />
      )
    }
    return ''
  }

  return (
    <>
      <SectionHeaderMenu menuData={sectionHeaderMenu} />
      <MDBCardBody>{renderTable()}</MDBCardBody>
      <Modal
        isOpen={modalOpen}
        toggle={toggleModal}
        headerText={headerText}
        includeFooter={footer}
        actionButtons={actions}
      >
        {renderModalBody()}
      </Modal>
    </>
  )
}

export default StudyBudgetVisitList
